import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/analytics";

/**
 * RouteAnalytics — emits a GA4 `page_view` event on every SPA route change.
 *
 * Must be rendered INSIDE <BrowserRouter>. Renders nothing.
 * Fires once on initial mount and again on every pathname/search change.
 */
export default function RouteAnalytics() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
